// Predefined card decks for estimation
export const CARD_DECKS = {
    FIBONACCI: {
        id: 'fibonacci',
        name: 'Fibonacci',
        values: ['0', '1', '2', '3', '5', '8', '13', '21', '?', '☕']
    },
    MODIFIED_FIBONACCI: {
        id: 'modified-fibonacci',
        name: 'Modified Fibonacci',
        values: ['0', '0.5', '1', '2', '3', '5', '8', '13', '20', '40', '?', '☕']
    },
    T_SHIRT: {
        id: 't-shirt',
        name: 'T-Shirt Sizes',
        values: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '?', '☕']
    },
    POWERS_OF_2: {
        id: 'powers-of-2',
        name: 'Powers of 2',
        values: ['0', '1', '2', '4', '8', '16', '32', '?', '☕']
    }
};
// Socket event names
export const SOCKET_EVENTS = {
    // Connection
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    // Room management
    JOIN_ROOM: 'join_room',
    LEAVE_ROOM: 'leave_room',
    ROOM_JOINED: 'room_joined',
    ROOM_LEFT: 'room_left',
    ROOM_UPDATED: 'room_updated',
    REMOVE_USER: 'remove_user',
    // Voting
    VOTING_STARTED: 'voting_started',
    VOTE_SUBMITTED: 'vote_submitted',
    VOTES_REVEALED: 'votes_revealed',
    VOTES_CLEARED: 'votes_cleared',
    // Stories
    STORY_CREATED: 'story_created',
    STORY_UPDATED: 'story_updated',
    // Timer
    START_TIMER: 'start_timer',
    PAUSE_TIMER: 'pause_timer',
    RESUME_TIMER: 'resume_timer',
    STOP_TIMER: 'stop_timer',
    TIMER_TICK: 'timer_tick',
    TIMER_COMPLETE: 'timer_complete',
    TIMER_UPDATED: 'timer_updated',
    // User status and heartbeat
    USER_STATUS_UPDATE: 'user_status_update',
    HEARTBEAT: 'heartbeat',
    // Final estimate
    FINAL_ESTIMATE_SET: 'final_estimate_set',
    // Errors
    ERROR: 'error'
};
// HTTP status codes
export const HTTP_STATUS = {
    OK: 200,
    CREATED: 201,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    FORBIDDEN: 403,
    NOT_FOUND: 404,
    CONFLICT: 409,
    INTERNAL_SERVER_ERROR: 500
};
// API endpoints
export const API_ENDPOINTS = {
    ROOMS: '/api/rooms',
    STORIES: '/api/stories',
    USERS: '/api/users'
};
// Validation constants
export const VALIDATION = {
    ROOM_NAME_MAX_LENGTH: 100,
    ROOM_DESCRIPTION_MAX_LENGTH: 500,
    STORY_TITLE_MAX_LENGTH: 200,
    STORY_DESCRIPTION_MAX_LENGTH: 1000,
    USER_NAME_MAX_LENGTH: 50,
    MAX_PARTICIPANTS: 20
};
// Timer constants
export const TIMER = {
    DEFAULT_DURATION: 300, // 5 minutes in seconds
    MIN_DURATION: 30, // 30 seconds
    MAX_DURATION: 3600, // 1 hour
    WARNING_THRESHOLD: 30, // Show warning when 30 seconds remain
    TICK_INTERVAL: 1000, // Update every second
    PRESET_DURATIONS: [
        { label: '1 min', value: 60 },
        { label: '2 min', value: 120 },
        { label: '3 min', value: 180 },
        { label: '5 min', value: 300 },
        { label: '10 min', value: 600 },
        { label: '15 min', value: 900 }
    ]
};
